import { createFileRoute } from '@tanstack/react-router';
import { SuggestionsScreen } from '../../screens/Suggestions';

export const Route = createFileRoute('/tasks/suggestions')({
  component: SuggestionsScreen,
});
